import React from "react";
import { Download, ExternalLink, QrCode } from "lucide-react";
import { Button } from "../components/ui/button";

const TARGET_URL = "https://asha.dental/fellow/dr-gressell";

const downloads = [
  { label: "PNG — Black", file: "/qr/dr-gressell-qr.png", name: "dr-gressell-qr-black.png", note: "Safest for any printer" },
  { label: "PNG — Asha Blue", file: "/qr/dr-gressell-qr-blue.png", name: "dr-gressell-qr-blue.png", note: "Brand color, 2048px" },
  { label: "SVG — Asha Blue", file: "/qr/dr-gressell-qr-blue.svg", name: "dr-gressell-qr-blue.svg", note: "Vector, any print size" },
];

const DrGressellQrPage = () => {
  return (
    <div className="min-h-screen bg-[#f7fafd] text-slate-900 antialiased flex flex-col">
      <header className="max-w-3xl w-full mx-auto px-5 pt-5 flex items-center justify-between">
        <a href="https://asha.dental" className="text-xl font-extrabold text-slate-900 tracking-tight">
          Asha <span className="text-blue-600">Dental</span>
        </a>
        <span className="text-[11px] sm:text-xs font-semibold text-slate-500 bg-white border border-blue-100 rounded-full px-3.5 py-1.5 shadow-sm">
          Internal — QR assets
        </span>
      </header>

      <main className="flex-1 flex items-center justify-center px-5 py-10">
        <div className="w-full max-w-md">
          <div className="text-center mb-6">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-blue-600 shadow-lg shadow-blue-200 mb-4">
              <QrCode className="w-6 h-6 text-white" />
            </div>
            <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight">Dr. Gressell referral QR</h1>
            <p className="mt-2 text-sm text-slate-500">
              Scans to{" "}
              <a href={TARGET_URL} className="font-semibold text-blue-600 hover:text-blue-700 inline-flex items-center gap-1">
                asha.dental/fellow/dr-gressell
                <ExternalLink className="w-3 h-3" />
              </a>
            </p>
          </div>

          <div className="bg-white rounded-3xl border border-blue-100 shadow-xl shadow-blue-900/[0.05] overflow-hidden">
            <div className="h-1 bg-gradient-to-r from-sky-400 via-blue-600 to-indigo-500" />
            <div className="p-6 sm:p-8">
              <div className="bg-white rounded-2xl border border-slate-200 p-4 max-w-[280px] mx-auto">
                <img src="/qr/dr-gressell-qr-blue.png" alt="QR code linking to the Dr. Gressell referral page" className="w-full h-auto" />
              </div>

              <div className="mt-6 space-y-2">
                {downloads.map((d) => (
                  <a key={d.file} href={d.file} download={d.name} className="block">
                    <Button
                      type="button"
                      variant="outline"
                      className="w-full h-11 justify-between rounded-xl border-slate-200 bg-slate-50 hover:bg-blue-50 hover:border-blue-200 text-sm font-semibold text-slate-800"
                    >
                      <span className="flex items-center gap-2">
                        <Download className="w-4 h-4 text-blue-600" />
                        {d.label}
                      </span>
                      <span className="text-[11px] font-medium text-slate-400">{d.note}</span>
                    </Button>
                  </a>
                ))}
              </div>

              <p className="mt-4 text-[11px] text-center text-slate-400">
                Generated with high error correction (level H) — safe for print at business-card size and up.
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default DrGressellQrPage;
